// Canonical Contacts.Ratings label map — single source of truth for V2.
// Verified against live Zoho metadata 2026-06-07 (getFields Contacts.Ratings)
// and scripts/zoho-picklist-snapshot-2026-05-25.json.
//
// RATING_API_VALUES are the stored/POSTed actual_values. RATING_LABELS holds
// only the three where Zoho admin renamed the display_value but kept the API
// value — everything else displays as-is. Glider is no longer in the active
// picklist (dropped from `used` values) so it's omitted from the entry list,
// but labelForRating still passes it through unchanged if it appears on an
// older record.
//
// Backend twin: utils/ratings-labels.js (CJS). Keep the two maps identical —
// tests/prestage-prefill-fields.test.js pins them in sync.

export const RATING_API_VALUES = [
  'SEL', 'Instrument Rated', 'MEL', 'SES', 'MES',
  'CFI', 'CFII', 'MEI', 'Helicopter', 'Turbo Jet',
];

export const RATING_LABELS = {
  'Instrument Rated': 'IFR',
  'Helicopter': 'Rotorwing',
  'Turbo Jet': 'Rotorwing Instrument',
};

export const labelForRating = (v) => RATING_LABELS[v] || v;

export const labelsForRatings = (arr) =>
  (Array.isArray(arr) ? arr : arr ? [arr] : []).map(labelForRating);
